<script lang="ts">
	import AppShell from '$lib/components/AppShell.svelte';
</script>

<AppShell />
